import { BenefitType } from '@/types/benefits/benefitTypes';
import CreateActivityPage from './CreateActivityPage';

const CreateTransferPage = () => {
  return <CreateActivityPage type={BenefitType.TRANSFER} />;
};

export default CreateTransferPage;
